module KendoWidgets
{
	export class DateTimePickerOptions implements kendo.ui.DateTimePickerOptions
	{
		name?: string;
		animation?: boolean | kendo.ui.DateTimePickerAnimation;
		ARIATemplate?: string;
		culture?: string;
		dateInput?: boolean;
		dates?: any;
		depth?: string;
		disableDates?: any | Function;
		footer?: boolean | string | Function;
		format?: string;
		interval?: number;
		max?: Date;
		min?: Date;
		month?: kendo.ui.DateTimePickerMonth;
		weekNumber?: boolean;
		parseFormats?: any;
		start?: string;
		timeFormat?: string;
		value?: Date;
		width?: string | number;
		wrapper?: string | JQuery | Element;
		enabled?: boolean;
		css?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;

		change?(e: kendo.ui.DateTimePickerChangeEvent): void;
		close?(e: kendo.ui.DateTimePickerCloseEvent): void;
		open?(e: kendo.ui.DateTimePickerOpenEvent): void;
	}

	export class DateTimePicker extends kendo.ui.DateTimePicker implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.DateTimePicker; }
		private _firstLoad: boolean;

		constructor(element: Element, options?: KendoWidgets.DateTimePickerOptions)
		{
			if (options == null)
				options = new KendoWidgets.DateTimePickerOptions();

			if (options.enabled == null) options.enabled = true;

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion
			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			super(element, options);

			element.parentElement!.parentElement!.id = element.id + "Parent";
			$(element).parent().parent().addClass("controlParent");

			if (!options.enabled)
				this.enable(false);

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.append(label);
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().parent().wrap(options!.wrapper!));
			//#endregion
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.show();
				else
					this.element.hide();
			}

			return this.element.is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		today()
		{
			this.value(Date.today());
		}

		clear()
		{
			this.value("");
		}

		value(date?: Date | string)
		{
			if (date != null)
			{
				if (typeof (date) == "string")
					date = Date.fixDateString(date);

				super.value(date);
			}

			return super.value();
		}

		isEmpty()
		{
			return (this.value() == null);
		}

		focus()
		{
			this.element.focus();
		}

		disable()
		{
			this.enable(false);
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().prependTo(element);
		}
		//#endregion
	}

	DateTimePicker.fn = DateTimePicker.prototype;
	DateTimePicker.fn.options = $.extend(true, {}, kendo.ui.DateTimePicker.fn.options);
	DateTimePicker.fn.options.name = "DateTimePicker";
	kendo.ui.plugin(DateTimePicker);
}

interface JQuery
{
	kendoDateTimePicker(options?: KendoWidgets.DateTimePickerOptions): JQuery;
}